import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full border border-accent-300 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
            Kategorien
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            OOPBuy Spreadsheet Kategorien
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto">
            Entdecke alle beliebten OOPBuy Produktkategorien – von Schuhen über Streetwear bis zu
            Accessoires, strukturiert aufbereitet für den schnellen Überblick.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat, idx) => (
            <a
              key={idx}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative overflow-hidden rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative w-full h-36 overflow-hidden rounded-t-xl">
                <img
                  src={cat.image}
                  alt={`OOPBuy Spreadsheet ${cat.name} Kategorie`}
                  title={`OOPBuy Spreadsheet ${cat.name}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              </div>
              <div className="flex items-center gap-3 p-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 group-hover:bg-accent-200 transition-colors duration-300">
                  <i className={`${cat.icon} text-sm text-accent-600 group-hover:text-accent-700 transition-colors duration-300`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-900 transition-colors duration-300 text-center leading-tight">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}